import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MarketService } from '../../../shared/services/market.service';
import { Auth } from 'aws-amplify';

@Component({
  selector: 'app-add-property',
  templateUrl: './add-property.component.html',
  styleUrls: ['./add-property.component.css']
})
export class AddPropertyComponent implements OnInit {

  addPropertyForm: FormGroup;
  customStylesValidated = false;
  isLoading: boolean = false;
  display: boolean = false;
  owner: any;

  constructor(
    private router: Router, 
    private route: ActivatedRoute, 
    private marketService: MarketService, 
    private fb: FormBuilder) {
    this.getCurrentAuthenticatedUser();
    this.addPropertyForm = this.fb.group({
      name: ['', [Validators.required]],
      status: ['', [Validators.required]],
      type: ['', [Validators.required]],
      industry: ['', [Validators.required]],
      noOfDays: ['', [Validators.required]],
      onSiteAttendance: ['', [Validators.required]],
      eventSite: ['', [Validators.required]],
      category: ['', [Validators.required]],
      description: ['']
    });
  }

  ngOnInit(): void {

    
  }

  getCurrentAuthenticatedUser() {
    // this.showMenu = false;
    Auth.currentAuthenticatedUser()
      .then((user) => {
        console.log(user.attributes.email);
        this.owner = user.attributes.email;
      },
        (error) => {
          console.log("authentication error", error);
          // this.userNotAuthenticated = error; 

          // this.isHidden = true;
        });
  }

  onAddNewProperty(){
    

    this.customStylesValidated = true;
    if(this.addPropertyForm.valid){
      
      this.isLoading = true;

      var newProperty = this.addPropertyForm.value;
      newProperty['owner'] = this.owner;  
      this.marketService.addProperty(newProperty).subscribe((data) => {
        
        console.log("data: ", data);

        setTimeout(() => {
          this.isLoading = false;
          this.router.navigate(['private-space/view-properties', {}]);
        }, 2500);
        
      }, (error) => {
        this.isLoading = false;
        console.log("error: ", error);
        
      });

    }else{
      this.display = true;
    }
    
  }


}
